import axios from 'axios';
import React, { useEffect, useState } from 'react'
import FilterComponent from '../../../CoreComponents/FilterComponent';
import ModalComponent from '../../../CoreComponents/FilterModalComponent'
import { DIFFERENCE_OF_ARRAYS, getToken, ManageCustomer } from '../../../Functionalities/Functions';
import ModalFilterComponent from './ModalFilterComponent';

function PromocodeComponent(props) {
    let existingUser = props.existingUser || []
    const [data, setData] = useState([])
    const [customerID, setCustomerID] = useState([])
    const [search, setSearch] = useState('')
    // void 0
    useEffect(() => {
        getData()
    }, [search])

    const setUserListFunction = () => {
        let userList_data = []
        if (existingUser.length > 0) {
            existingUser.map(item => {
                userList_data.push(item.id)
            })
            return userList_data
        }
        return userList_data
    }


    const getData = () => {
        if (existingUser != "") {
            if (existingUser.length > 0) {
                var list = setUserListFunction()
                // alert(list)
                let result = ManageCustomer('', '', 'get', `keyword=all_profile&dropdown=true&is_branch_admin=false&is_manager=false&search_text=${search}&exclude_users=[${list}]`)
                result.then(result => {
                    setData(result.data.results)
                })
            }
        }
        if (existingUser.length == 0) {
            let result = ManageCustomer('', '', 'get', `keyword=all_profile&dropdown=true&is_branch_admin=false&is_manager=false&search_text=${search}`)
            result.then(result => {
                setData(result.data.results)
            })
        }
    }

    function Pop(id) {
        var array = customerID
        var index = array.indexOf(id)
        if (index !== -1) {
            array.splice(index, 1)
            setCustomerID(array)
        }
        console.warn("pop")
        console.warn(customerID)
    }
    function Push(id) {

        var array = customerID
        var index = array.indexOf(id)
        if (index == -1) {
            customerID.push(id)
        }
        console.warn("push")
        console.warn(customerID)
    }

    


    const loop = () => {
        existingUser.length > 0 && existingUser.map((user, index) => {
            Push(user.id)
        })
    }
    existingUser && loop()
    return (
        <div>

            <div className="modal fade" id="userSelectModal">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <ModalFilterComponent searchFunction={(data) => {
                            setSearch(data)
                        }} />
                        {/* <FilterComponent handleNext={handleNext} handlePrev={handlePrev} next={next} prev={prev} /> */}
                        <div className="modal-header">
                            <h5 className="modal-title">Select Customer</h5>
                            <button type="button" className="close" data-dismiss="modal"><span>×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="table-responsive rounded card-table">
                                <table className="table items-table table-responsive-sm">
                                    <tbody>
                                        <tr>
                                            <th className="my-0 text-black font-w500 fs-3">
                                                Customer
                                    </th>
                                            <th className="my-0 text-black font-w500 fs-3">
                                                Select
                                    </th>
                                        </tr>
                                        {data.length > 0 &&
                                            data.map((item, index) => {
                                                return (
                                                    <tr className="alert alert-dismissible border-0">
                                                        <td>
                                                            <div className="media">
                                                                <div className="media-body">
                                                                    <small className="font-w500">
                                                                        <a className="text-primary" href="javascript:void(0);">
                                                                            FDRCSR{item.id} :{item.first_name} </a>
                                                                    </small>
                                                                    <br />
                                                                    <small className="font-w500">
                                                                        <a className="text-dark" href="javascript:void(0);" >
                                                                            {item.details && item.details.mobile}</a>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <h4 className="my-0 text-black font-w600">
                                                                {existingUser ?
                                                                    <input type="checkbox" id={index}
                                                                        // checked={customerID.includes(item.id)}
                                                                        onChange={
                                                                            (e) => {
                                                                                e.target.checked == true ?
                                                                                    Push(item.id)
                                                                                    :
                                                                                    Pop(item.id)
                                                                                // setCustomerID([...customerID, item.id])

                                                                            }
                                                                        }
                                                                    /> :
                                                                    <input type="checkbox" id={index}
                                                                        onChange={
                                                                            (e) => {
                                                                                e.target.checked == true ?
                                                                                    Push(item.id)
                                                                                    :
                                                                                    Pop(item.id)
                                                                                // setCustomerID([...customerID, item.id])

                                                                            }
                                                                        }
                                                                    />
                                                                }
                                                            </h4>

                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger light" data-dismiss="modal" onClick={
                                (e) => {
                                    e.preventDefault()
                                    setCustomerID([])
                                }
                            }
                            >Close</button>
                            <button type="button" className="btn btn-primary" data-dismiss="modal"
                                onClick={
                                    (e) => {
                                        e.preventDefault()
                                        // void 0
                                        // return 0
                                        props.customerFunction(customerID)
                                    }
                                }
                            >Select Customer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PromocodeComponent
